import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private httpClient: HttpClientService) {}

  changePassword(payload: {
    email: string;
    new_password: string;
    confirm_password: string;
  }): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.profile.changePassword,
      payload
    );
  }
}
